import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.includes.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.items.length ? _c("div", {
    staticClass: "file-list",
    attrs: {
      id: "image-container"
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c("div", {
      key: item.id
    }, [item.type == "image" ? [_c("div", {
      staticClass: "file"
    }, [_c("img", {
      staticClass: "file-image",
      attrs: {
        src: item.url
      }
    }), _c("p", {
      staticClass: "file-text"
    }, [_vm._v(_vm._s(item.name))]), item.status === "pending" || item.status === "cancel" ? _c("i", {
      staticClass: "trash-icon fas fa-trash-alt",
      attrs: {
        title: "Delete"
      },
      on: {
        click: function click($event) {
          return _vm.destroy(index, item.url);
        }
      }
    }) : _vm._e()])] : [_c("div", {
      staticClass: "file"
    }, [item.name.includes(".xls") ? _c("img", {
      staticClass: "file-image",
      attrs: {
        src: _vm.xlsx
      }
    }) : item.name.includes(".pdf") ? _c("img", {
      staticClass: "file-image",
      attrs: {
        src: _vm.pdf
      }
    }) : _c("img", {
      staticClass: "file-image",
      attrs: {
        src: _vm.fileSrc
      }
    }), _c("p", {
      staticClass: "file-text"
    }, [_vm._v(_vm._s(item.name))]), item.status == "pending" || item.status == "cancel" ? _c("i", {
      staticClass: "trash-icon fas fa-trash-alt",
      attrs: {
        title: "Delete"
      },
      on: {
        click: function click($event) {
          return _vm.destroy(index, item.url);
        }
      }
    }) : _vm._e()])]], 2);
  }), 0) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };